import * as React from 'react';
import {Accordion, AccordionItem} from '@deviceinsight/ng-ui-basic-components';

import {ServiceStatus, Instance} from '../../modules/servicestatus/types';

type Props = {
	accordionClass: string;
	activeFilter: string | null | undefined;
	platformStatus: Array<ServiceStatus>;
};

export default class ServiceStatusAccordion extends React.PureComponent<Props> {
	renderAccordionPages = () => {
		const {activeFilter, platformStatus} = this.props;
		return platformStatus
			.sort((a, b) => {
				if (a.name > b.name) return 1;
				if (a.name < b.name) return -1;
				return 0;
			})
			.map<React.ReactNode>((status, index) => {
				if (!!activeFilter && activeFilter !== status.status) return null;
				const content = <ul className="endpoint">{this.renderInstances(status.instances)}</ul>;
				return (
					<AccordionItem
						key={index}
						data-testid={`service-status-accordion-item-${index}`}
						title={status.name}
						itemClasses={`item-status-${status.status}`}>
						{content}
					</AccordionItem>
				);
			});
	};

	renderInstances(instances: Array<Instance>) {
		return instances.map<React.ReactNode>((instance, index) => {
			const instanceDetails = instance.statusInfo.details;
			return (
				<li key={instance.id}>
					<span
						className={`endpoint-status ${instance.statusInfo.status}`}
						data-testid="service-status-item-title">
						Instance {index + 1}: {instance.statusInfo.status}
					</span>
					<ul>
						{Object.keys(instanceDetails).map((key) => {
							const instanceDetail = instanceDetails[key].status
								? instanceDetails[key].status
								: instanceDetails[key];
							return (
								<li key={key + instance.id} className={`endpoint-status ${instanceDetail}`}>
									{key}: {instanceDetail}
								</li>
							);
						})}
					</ul>
				</li>
			);
		});
	}

	render() {
		const {accordionClass} = this.props;
		return <Accordion accordionClass={accordionClass}>{this.renderAccordionPages()}</Accordion>;
	}
}
